// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Db from "../../backend/Db.bs.jsx";
import * as Rxjs from "../../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as UserRoles from "../../backend/UserRoles.bs.jsx";
import * as Reactfire from "reactfire";
import * as ReactUpdate from "rescript-react-update/src/ReactUpdate.bs.jsx";
import * as Auth from "rxfire/auth";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Firestore from "rxfire/firestore";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.jsx";

function ShareLinkResolver$Pure(props) {
  let onAccept = props.onAccept;
  let data = props.data;
  let tmp;
  let exit = 0;
  if (data !== undefined && onAccept !== undefined) {
    let role = Stdlib_Option.getOrThrow(Stdlib_Option.map(UserRoles.roleFromInt(data[0].role), UserRoles.roleI18n), undefined);
    tmp = <>
      <p>
        {`Dovolujeme si vás pozvat do výčeního místa `}
        <b>
          {data[1].name}
        </b>
        {`.  Vaše role bude `}
        <i>
          {role}
        </i>
      </p>
      <div>
        <button
          className={Styles.button.variantPrimary}
          disabled={props.loading}
          type={"button"}
          onClick={param => onAccept()}
        >
          {"Přijmout pozvání"}
        </button>
      </div>
    </>;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = <>
      <p>
        {`Omlouváme se, ale pozvánka, `}
        <b>
          {`již není platná`}
        </b>
        {`. Možná jste jí už přijali, nebo vypršela její platnost.`}
      </p>
      <p>
        {`Podívejte se, jestli místo, kam se chcete přihlásit, nefiguruje na vašem seznamu míst. Když
            tam místo nenajdete, požádejte správce místa aby vám poslal novou pozvánku.`}
      </p>
      <div>
        <a
          className={Styles.button.variantPrimary}
          href={"/misto"}
        >
          {"Můj seznam míst"}
        </a>
      </div>
    </>;
  }
  return <div
    className={Styles.page.centered}
  >
    <h1
      className={Styles.utility.srOnly}
    >
      {"Check.beer"}
    </h1>
    <h2>
      {"Pozvánka"}
    </h2>
    {tmp}
  </div>;
}

let Pure = {
  make: ShareLinkResolver$Pure
};

function redirectToPlace(placeId) {
  RescriptReactRouter.replace(`/misto/` + placeId);
}

function pageDataRx(auth, firestore, linkId) {
  let currentUserRx = Auth.user(auth).pipe(Rxjs.keepMap(prim => {
    if (prim === null) {
      return;
    } else {
      return Primitive_option.some(prim);
    }
  }));
  let shareLinkRx = Firestore.docData(Db.ShareLink.document(firestore, linkId), { "idField": "uid" });
  let shareLinkPlaceRx = shareLinkRx.pipe(Rxjs$1.switchMap(maybeShareLink => {
    if (maybeShareLink !== undefined) {
      return Firestore.docData(Db.placeDocument(firestore, maybeShareLink.place), { "idField": "uid" });
    } else {
      return Rxjs$1.of(undefined);
    }
  }));
  Rxjs.op(Rxjs.op(Rxjs$1.combineLatest(currentUserRx, shareLinkPlaceRx), Rxjs$1.first()), Rxjs$1.tap(param => {
    let maybeShareLinkPlace = param[1];
    if (maybeShareLinkPlace === undefined) {
      return;
    }
    let userAlreadyInPlace = Stdlib_Option.isSome(maybeShareLinkPlace.accounts[param[0].uid]);
    if (userAlreadyInPlace) {
      Db.ShareLink.$$delete(firestore, linkId);
      return redirectToPlace(Db.getUid(maybeShareLinkPlace));
    }
  })).subscribe(param => {});
  return Rxjs$1.combineLatest(currentUserRx, shareLinkRx, shareLinkPlaceRx);
}

function ShareLinkResolver(props) {
  let linkId = props.linkId;
  let auth = Reactfire.useAuth();
  let firestore = Reactfire.useFirestore();
  let pageDataStatus = Reactfire.useObservable(`page_ShareLinkResolver_` + linkId, pageDataRx(auth, firestore, linkId));
  let match = pageDataStatus.data;
  if (match !== undefined) {
    let shareLink = match[1];
    if (shareLink !== undefined) {
      let shareLinkPlace = match[2];
      if (shareLinkPlace !== undefined) {
        let currentUser = match[0];
        let match$1 = ReactUpdate.useReducer((state, action) => {
          if (typeof action === "object") {
            if (typeof state !== "object" && state === "Pending") {
              return {
                TAG: "Update",
                _0: {
                  TAG: "Error",
                  _0: action._0
                }
              };
            } else {
              return "NoUpdate";
            }
          }
          if (action !== "Run") {
            if (typeof state !== "object" && state === "Pending") {
              return {
                TAG: "UpdateWithSideEffects",
                _0: "Success",
                _1: param => {
                  redirectToPlace(shareLink.place);
                }
              };
            } else {
              return "NoUpdate";
            }
          }
          if (typeof state !== "object") {
            switch (state) {
              case "Ready" :
                break;
              case "Pending" :
              case "Success" :
                return "NoUpdate";
            }
          }
          return {
            TAG: "UpdateWithSideEffects",
            _0: "Pending",
            _1: param => {
              let send = param.send;
              Stdlib_Promise.$$catch(Db.ShareLink.acceptInvitation(firestore, linkId, currentUser.uid).then(() => {
                send("Resolved");
                return Promise.resolve();
              }), error => {
                send({
                  TAG: "Rejected",
                  _0: error
                });
                return Promise.resolve();
              });
            }
          };
        }, "Ready");
        let acceptInviteSend = match$1[1];
        return <Pure.make
          data={[
            shareLink,
            shareLinkPlace
          ]}
          loading={match$1[0] === "Pending"}
          onAccept={() => acceptInviteSend("Run")}
        />;
      }
    }
  }
  return <Pure.make
    data={undefined}
  />;
}

let make = ShareLinkResolver;

export {
  Pure,
  redirectToPlace,
  pageDataRx,
  make,
}
/* Db Not a pure module */
